import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const Delinator = () => {
  

  const features = [
    {
      title: '고휘도 반사성능',
      bullets: [
      {
        label: (
          <>차량 헤드라이트를 효과적으로 반사하여 장거리에서도 선명한 시인성을 제공함</>
        ),
      },
      ]
    },
    {
      title: '우수한 내구성',
      bullets: [
      {
        label: (
          <>자외선·강풍·충격 등에 대한 내후성과 내충격성이 뛰어나 장기간 안정적으로 사용 가능함</>
        ),
      },
      ]
    },
    {
      title: '다양한 설치 호환성',
      bullets: [
      {
        label: (
          <>가드레일용, 방호울타리용, 폴형 등 다양한 규격으로 제작되어 도로 구조 및 설치 환경에 맞게 적용할 수 있음</>
        ),
      },
      ]
    },
    {
      title: '유지관리 효율성',
      bullets: [
      {
        label: (
          <>반사판 교체형 구조를 적용해 유지보수가 용이하며, 관리 비용 절감 효과가 있음</>
        ),
      },
      ]
    },
    {
      title: '표준화된 색상 및 디자인',
      bullets: [
      {
        label: (
          <>백색·황색 등 도로 기준에 적합한 색상으로 제작되어 운전자에게 일관된 시각 정보를 제공함</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`델리네이터`}
        subtitle={`야간 및 악천후 환경에서 도로의 선형을 명확하게 \n안내하여 안전 주행을 지원합니다`}
        backgroundImage="/images/products/traffic-safety/delinator2.png"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '델리네이터' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`주야간 필수 교통안전 시설`}
        title={`델리네이터`}
        description={
          <>
            델리네이터는 야간 및 악천후 환경에서 도로의 선형을 명확하게 안내하여 {' '}
            운전자의 시야 확보와 안전 주행을 지원하는 필수 교통안전 시설입니다.
            <br />
            <br />
            반사체를 적용하여 빛을 효과적으로 반사하며, 위험 구간의 시인성을 높여 사고를 사전에 예방합니다.{' '}
            이와 같은 활용을 통해 도로 전 구간의 안전성이 향상될 뿐만 아니라, {' '}
            공사·정비 구간에서는 작업자의 안전 확보와 원활한 차량 흐름 유지에도 기여합니다.
          </>
        }
        images={[
          '/images/products/traffic-safety/delinator3.png',
          '/images/products/traffic-safety/delinator5.png',
          '/images/products/traffic-safety/delinator4.png',
          '/images/products/traffic-safety/delinator2.jpg',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="traffic-safety"
        currentPath="/products/traffic-safety/delinator"
        listPath="/products/traffic-safety"
      />


      <CTASection />
    </>
  );
};

export default Delinator;
